import http from "@/utils/request"

export default {
	captcha: async function (data = {}) {
		return await http.get("captcha", data);
	},
	login: async function (data = {}) {
		return await http.post("login", data);
	},
	info: async function () {
		return await http.get("info");
	},
	menu: async function (data = {}) {
		return await http.get("menu", data)
	},
	logout: async function(){
		return await http.get("logout");
	},
	saveTag: async function(data = {}) {
		return await http.post("save/tag", data);
	},
	saveInfo: async function(data = {}) {
		return await http.post("save/info", data);
	},
	loginLog: async function(data){
		return await http.get("log/login", data);
	},
	savePass: async function(data = {}) {
		return await http.post("save/pass", data);
	},
}
